import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getEvents } from "../../api/events";
import EventsTable from "./EventsTable";
import { updateEvents } from "../../store/mainReducer";

export const EventsPage = ({ userData }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(async () => {
    if (userData) {
      try {
        setLoading(true);

        const events = await getEvents(
          userData?._id,
          userData?.operators[0].api_key
        );

        dispatch(updateEvents(events.data));

        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  }, []);

  return (
    <div className="container-column" id="events-page">
      {userData?.events_list?.length === 0 ? (
        <div className="no-events">
          <p id="subTitle">
            After you create an event, you can manage it from here
          </p>
        </div>
      ) : (
        <EventsTable userData={userData} loading={loading} />
      )}
    </div>
  );
};
